/**
 * Cart drawer Apple Pay CTA — only visible when Shopify dynamic checkout
 * includes Apple Pay; click triggers that wallet control (no checkout fallback).
 */
(function () {
  if (window.__peggellCartApplePayBound) return;
  window.__peggellCartApplePayBound = true;

  const BUTTON = '[data-peggell-apple-pay]';

  function canDeviceDoApplePay() {
    try {
      if (window.ApplePaySession && typeof ApplePaySession.canMakePayments === 'function') {
        return ApplePaySession.canMakePayments();
      }
    } catch (e) {
      /* ignore */
    }
    return true;
  }

  function labelOf(el) {
    if (!el || el.nodeType !== 1) return '';
    return (
      el.getAttribute('aria-label') ||
      el.getAttribute('title') ||
      el.getAttribute('data-testid') ||
      el.getAttribute('name') ||
      el.id ||
      (typeof el.className === 'string' ? el.className : '') ||
      el.tagName ||
      ''
    ).toLowerCase();
  }

  function looksLikeApplePay(el) {
    if (!el || el.nodeType !== 1) return false;
    const tag = el.tagName.toLowerCase();
    if (tag === 'apple-pay-button') return true;
    const label = labelOf(el);
    if (label.includes('apple pay') || label.includes('applepay') || label.includes('apple-pay')) {
      return true;
    }
    if (tag === 'iframe') {
      const src = (el.getAttribute('src') || '').toLowerCase();
      const title = (el.getAttribute('title') || '').toLowerCase();
      if (src.includes('apple') || title.includes('apple')) return true;
    }
    return false;
  }

  function collectApplePayTargets(root) {
    const found = [];
    const seen = new Set();

    function visit(node) {
      if (!node || seen.has(node)) return;
      if (node.nodeType === 1) {
        seen.add(node);
        if (looksLikeApplePay(node)) found.push(node);
        if (node.shadowRoot) visit(node.shadowRoot);
        const children = node.children || [];
        for (let i = 0; i < children.length; i++) visit(children[i]);
      } else if (node.nodeType === 11) {
        const children = node.children || [];
        for (let i = 0; i < children.length; i++) visit(children[i]);
      }
    }

    visit(root);

    try {
      root
        .querySelectorAll(
          'apple-pay-button, [aria-label*="Apple Pay" i], [aria-label*="ApplePay" i], [data-testid*="ApplePay" i], [data-testid*="apple-pay" i], iframe[title*="Apple" i], iframe[name*="apple" i]'
        )
        .forEach((el) => {
          if (!found.includes(el)) found.push(el);
        });
    } catch (e) {
      /* older browsers may not support case-insensitive attribute selectors */
      root.querySelectorAll('apple-pay-button, iframe').forEach((el) => {
        if (looksLikeApplePay(el) && !found.includes(el)) found.push(el);
      });
    }

    return found;
  }

  function getDynamicRoot(drawer) {
    return (
      drawer.querySelector('#dynamic-checkout-cart') ||
      drawer.querySelector('.cart-drawer__dynamic-checkout-hidden')
    );
  }

  function setApplePayVisible(button, visible) {
    if (!button) return;
    const nextHidden = !visible;
    if (button.hidden !== nextHidden) button.hidden = nextHidden;
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (button.hasAttribute('data-cart-empty')) {
      button.disabled = true;
    } else {
      button.disabled = !visible;
    }
  }

  function syncApplePayButton(drawer) {
    if (!drawer) return;
    const button = drawer.querySelector(BUTTON);
    if (!button) return;

    if (drawer.classList.contains('is-empty') || button.hasAttribute('data-cart-empty')) {
      setApplePayVisible(button, false);
      button._peggellApplePayTargets = [];
      return;
    }

    if (!canDeviceDoApplePay()) {
      setApplePayVisible(button, false);
      button._peggellApplePayTargets = [];
      return;
    }

    const dynamicRoot = getDynamicRoot(drawer);
    if (!dynamicRoot) {
      setApplePayVisible(button, false);
      button._peggellApplePayTargets = [];
      return;
    }

    const targets = collectApplePayTargets(dynamicRoot);
    button._peggellApplePayTargets = targets;
    setApplePayVisible(button, targets.length > 0);
  }

  function triggerApplePay(button) {
    const drawer = button.closest('cart-drawer');
    if (!drawer) return;

    const dynamicRoot = getDynamicRoot(drawer);
    if (!dynamicRoot) return;

    let targets = button._peggellApplePayTargets;
    if (!targets || !targets.length) {
      targets = collectApplePayTargets(dynamicRoot);
      button._peggellApplePayTargets = targets;
    }
    if (!targets.length) return;

    dynamicRoot.classList.add('cart-drawer__dynamic-checkout-armed');

    const target = targets[0];
    try {
      target.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true, cancelable: true, view: window }));
      target.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
      target.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
      target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      if (typeof target.click === 'function') target.click();
    } catch (e) {
      /* ignore */
    }

    window.setTimeout(() => {
      dynamicRoot.classList.remove('cart-drawer__dynamic-checkout-armed');
    }, 1500);
  }

  function watchDynamicRoot(drawer, dynamicRoot) {
    if (!dynamicRoot || dynamicRoot._peggellApplePayObserved) return;
    dynamicRoot._peggellApplePayObserved = true;

    const observer = new MutationObserver(() => syncApplePayButton(drawer));
    observer.observe(dynamicRoot, { childList: true, subtree: true, attributes: true });

    let tries = 0;
    const poll = window.setInterval(() => {
      syncApplePayButton(drawer);
      tries += 1;
      if (tries >= 24) window.clearInterval(poll);
    }, 250);
  }

  function initDrawer(drawer) {
    if (!drawer) return;
    syncApplePayButton(drawer);
    const dynamicRoot = getDynamicRoot(drawer);
    watchDynamicRoot(drawer, dynamicRoot);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUTTON);
    if (!button || button.hidden || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    triggerApplePay(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initDrawer(document.querySelector('cart-drawer'));
  });

  // Re-init when cart drawer section HTML is replaced
  const drawerHost = document.querySelector('cart-drawer');
  if (drawerHost) {
    let timer = null;
    const hostObserver = new MutationObserver((mutations) => {
      const structural = mutations.some((m) =>
        Array.from(m.addedNodes).some(
          (n) =>
            n.nodeType === 1 &&
            (n.matches?.(BUTTON) ||
              n.matches?.('.cart-drawer__dynamic-checkout-hidden') ||
              n.matches?.('#dynamic-checkout-cart') ||
              n.querySelector?.(BUTTON) ||
              n.querySelector?.('#dynamic-checkout-cart') ||
              n.querySelector?.('.cart-drawer__dynamic-checkout-hidden'))
        )
      );
      if (!structural) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => initDrawer(drawerHost), 80);
    });
    hostObserver.observe(drawerHost, { childList: true, subtree: true });
  }

  window.peggellSyncCartApplePay = () => initDrawer(document.querySelector('cart-drawer'));
})();
